// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.router-outlet {
  margin-top: var(--header-height);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
